export default __webpack_public_path__ + "static/media/nero.e30f4fce.png";